import React, { useEffect, forwardRef, RefObject } from "react";
import PropTypes from "prop-types";
import { Dimensions, StyleSheet } from "react-native";
import { MD3Theme, useTheme } from "react-native-paper";
import PhoneInput from "react-native-phone-input";
import { PhoneInputProps } from "../types/types";

const PhoneInputCustom = forwardRef((props: PhoneInputProps, ref: RefObject<PhoneInput>) => {
  const { value, onChangeText, placeholder, additionalStyle, editable } = props;
  const theme = useTheme();
  const styles = stylesGen(theme);

  useEffect(() => {
    if (ref?.current) {
      ref.current.setValue(value);
    }
  }, [value, ref]);

  return (
    <PhoneInput
      ref={ref}
      initialCountry="FR"
      autoFormat={true}
      style={{ ...styles.input, ...additionalStyle}}
      textStyle={{ ...styles.text, ...additionalStyle }}
      initialValue={value}
      textProps={{
        placeholder: placeholder,
      }}
      onChangePhoneNumber={onChangeText}
      disabled={!editable}
    />
  );
});

PhoneInputCustom.propTypes = {
  value: PropTypes.string.isRequired,
  onChangeText: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  additionalStyle: PropTypes.object,
  editable: PropTypes.bool,
};

PhoneInputCustom.displayName = "PhoneInputCustom";

const stylesGen= (theme: MD3Theme) => StyleSheet.create({
  input: {
    borderWidth: 1,
    width: "100%",
    borderColor: theme.colors.tertiary,//"lightgray",
    paddingHorizontal: 10,
    borderRadius: 15,
    height: 35,
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    textAlign: "center",
    color: theme.colors.onBackground,
    fontFamily: "NotoSans-Regular",
    fontSize: Dimensions.get("screen").height / 45,
    height: '100%',
    textAlignVertical: 'center',
    paddingTop: 0,
    paddingBottom: 0,
  },
});

export default PhoneInputCustom;